import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JobsService } from 'src/app/services/jobs.service';
import { NotificationService } from 'src/app/services/notification.service';
import { tap } from 'rxjs/operators';
import { ValidationUtilityService } from 'src/app/services/validation-utility.service';
import { MentorshipService } from 'src/app/services/mentorship.service';
import { topRatedMentor } from 'src/app/model/mentorship';
import { AuthorizationService } from 'src/app/services/authorization.service';

@Component({
  selector: 'app-jobportal',
  templateUrl: './jobportal.component.html',
  styleUrls: ['./jobportal.component.scss']
})
export class JobportalComponent implements OnInit {
  jobList: any[] = [];
  selectedCompanyName: string = '';
  loader: boolean = false;
  keyword: string = '';
  totalJobs: number = 0;

  showFilterModal: boolean = false;

  // for scroll pagination
  currentPage: number = 1;
  noMoreData: boolean = false;

  isSearchEnabled: boolean = false;
  loaderTopRatedMentors:boolean = false;
  topRatedMentorsList:any[] = [];

  constructor(private router: Router, private jobService: JobsService, 
    private ns: NotificationService, 
    private validationUtility: ValidationUtilityService,
  private mentorshipService:MentorshipService,
  public perm:AuthorizationService) {
  }


  /**
   * Angular lifecycle hook that is called after data-bound properties are initialized.
   * Checks user permission and applies initial filters to load jobs.
   */
  ngOnInit() {
    this.applyFilters();
    this.getTopRatedMentorList(1);
  }

  /**
   * To validate search keyword and prevent not allowed chars
   */
  onInputSearchKeyword(event: KeyboardEvent) {
    return this.validationUtility.validateInput(event);
  }

   /**
   * To disable search and load all jobs
   */
  onHandleKeyup(event: any) {
    if(this.isSearchEnabled && this.keyword === '') {
      this.isSearchEnabled = false;
      this.resetScroll();
      this.applyFilters();
    }
  }

  /**
   * Handles the search action for jobs based on the entered keyword.
   * Returns early if the keyword is empty or whitespace.
   */
  onSearchJob() {
    if(!this.keyword.trim()) {
      return false;
    }
    else if(this.keyword.trim().length < 3) {
      this.ns.showNotification('error', 'Search text must be at least 3 characters long.');
      return false;
    }
    this.isSearchEnabled = true;
    this.resetScroll();
    this.applySearch();
  }

  /**
   * Applies search and fetches the job list for the current page.
   */
  applySearch() {
    this.loader = true;
    const query = this.keyword.trim();
    this.jobService.searchJobs(query, this.currentPage).subscribe({
      next: (res) => {
        this.loader = false;
        this.totalJobs = res.total_pages * 20;
        if (res.data.length > 0) {
          this.jobList.push(...res.data);
          if (this.currentPage == res.total_pages) {
            this.noMoreData = true;
          }
        }
        else {
          this.jobList = [];
        }
        if(res.total_pages <= 0) {
          this.noMoreData = true;
        }
      },
      error: (err) => {
        this.loader = false;
        this.ns.showNotification("error", err.message);
      }
    });
  }

  /**
   * Applies filters and fetches the job list for the current page.
   * Updates job list, total jobs, and handles loader and error notifications.
   */
  applyFilters() {
    let condition = {}
    let applyFilter = {
      condition: condition
    }
    this.loader = true;
    this.jobService.getJobs(this.currentPage).subscribe({
      next: (res) => {
        this.loader = false;
        this.totalJobs = res.total_pages * 20;
        if (res.jobs.length > 0) {
          this.jobList.push(...res.jobs);
          if (this.currentPage == res.total_pages) {
            this.noMoreData = true;
          }
        }
        else {
          this.jobList = [];
        }
        if(res.total_pages <= 0) {
          this.noMoreData = true;
        }
      },
      error: (err) => {
        this.loader = false;
        this.ns.showNotification("error", err.message);
      }
    });
  }


  /**
   * Opens the filter modal dialog.
   */
  openModal() {
    this.showFilterModal = true;
  }


  /**
   * Handles actions from the filter modal dialog.
   * Closes the modal based on the action status.
   * @param - Object containing the status of the modal action
   */
  onModalAction({ status }) {
    if (status == 'confirmed') {
      this.showFilterModal = false;
    }
    else {
      this.showFilterModal = false;
    }
  }


  /**
   * Loads more job data when the user scrolls, if more data is available.
   */
  onScroll() {
    if (this.noMoreData || this.loader) return;
    this.currentPage++;
    if(!this.isSearchEnabled) {
      this.applyFilters();
    }
    else {
      this.applySearch();
    }
  }

  /**
   * Resets the scroll pagination and job list to initial state.
   */
  resetScroll() {
    this.currentPage = 1;
    this.noMoreData = false;
    this.jobList = [];
  }

 /**
   * To get the top rated mentor
   *
   * @param {number} page - To get Page number
   */
 getTopRatedMentorList(page:any){
     this.loaderTopRatedMentors = true;
     this.topRatedMentorsList = [];
     this.mentorshipService.getTopRatedMentors(page).subscribe((responseData:topRatedMentor)=>{
       this.topRatedMentorsList = responseData.data;
      this.loaderTopRatedMentors = false;
     }, (error)=>{
      this.loaderTopRatedMentors = false;
      this.ns.showNotification("error", error.message);
     })
  }
  
  /**
   * To show mentor profile
   *
   * @param {string} mentorId - To get mentor id
   */
  onViewProfile(mentorId: string) {
    this.router.navigate(['/mentorship/mentor-profile'], { queryParams: { id: mentorId } });
  }


}
